import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DropdownsResolve } from './add-request-form/dropdowns-resolve.service';
import { AuthGuard } from '../../../../core/auth/auth.guard';
import { HeadendSummaryResolve } from '../shared/headend-summary-resolve.service';
import { HeadendIdGuard } from '../shared/headend-id-guard.service';
import { AddRequestComponent } from './add-request.component';
import { HeadendSummaryClearGuard } from '../shared/headend-summary-clear.guard';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: 'signals/add-service',
				component: AddRequestComponent,
				canActivate: [AuthGuard, HeadendIdGuard],
				canDeactivate: [HeadendSummaryClearGuard],
				resolve: {
					dropdowns: DropdownsResolve,
					headendSummary: HeadendSummaryResolve
				}
			}
		])
	],
	exports: [
		RouterModule
	],
	providers: [
		DropdownsResolve,
		HeadendSummaryResolve,
		HeadendIdGuard,
		HeadendSummaryClearGuard
	]
})

export class AddRequestRoutingModule {
}